import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getOnboardingsSimple = (query) => axios.get(toQueryString("api/v1/onboarding-survey-managements/simple?", query));

// LF360-1828: project-wide onboarding questions for the behavior-rules editor
// (fetchOnboardingQuestions condition source).
const getQuestions = () => axios.get("api/v1/onboarding-survey-managements/questions");

const getScenarios = (query) => axios.get(toQueryString("api/v1/onboarding-survey-managements?", query));

const getScenarioById = (id, query) =>
  axios.get(toQueryString(`api/v1/onboarding-survey-managements/${id}?`, query));

const deleteScenario = (id) =>
  axios.delete(`api/v1/onboarding-survey-managements/${id}`);

const removeBulk = (ids) => axios.delete("api/v1/onboarding-survey-managements/bulk", { data: { ids } });

const updateScenario = (id, params) =>
  axios.put(`api/v1/onboarding-survey-managements/${id}`, params);

const updateScenarioVersion = (scenarioVersionId, params) =>
  axios.put(
    `api/v1/onboarding-survey-managements/version/${scenarioVersionId}`,
    params
  );

const createScenario = () => axios.post("api/v1/onboarding-survey-managements");

const activateScenario = (versionId) =>
  axios.put(
    `api/v1/onboarding-survey-managements/version/${versionId}/activate`
  );

const discardScenarioChanges = (versionId) =>
  axios.put(
    `api/v1/onboarding-survey-managements/version/${versionId}/discard`
  );

const duplicateScenario = (scenarioId) =>
  axios.post(`api/v1/onboarding-survey-managements/${scenarioId}/duplicate`);

const getAlternativeMessages = (originalMessage, alreadyGeneratedMessages) =>
  axios.post(`api/v1/scenario-managements/alternative-messages`, {
    originalMessage,
    alreadyGeneratedMessages,
  });

const getAllMessages = async () => {
  const response = (await axios.get(`api/v1/scenario-managements/all-messages`))
    .data;

  return {
    data: response.data,
  };
};

const ApiOnboardingManagement = {
  getScenarios,
  getScenarioById,
  deleteScenario,
  removeBulk,
  updateScenario,
  updateScenarioVersion,
  createScenario,
  activateScenario,
  discardScenarioChanges,
  duplicateScenario,
  getOnboardingsSimple,
  getQuestions,
  getAlternativeMessages,
  getAllMessages
};

export default ApiOnboardingManagement;